import loadable from '@loadable/component';
import { createContext } from '@shared/utils/createContext';

interface ViewContext {
  changeView: (view: SupportedView) => void;
  currentView: SupportedView;
}

const SignIn = loadable(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/signIn" */
      '@apps/acquisitionFunnels/createWedding/routes/SignIn/SignIn'
    ),
);

const CreateAccount = loadable(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/createAccount" */
      '@apps/acquisitionFunnels/createWedding/routes/CreateAccount/CreateAccount'
    ),
);

const CreateWeddingForm = loadable(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/createWeddingForm" */
      '@apps/acquisitionFunnels/createWedding/routes/CreateWeddingForm/CreateWeddingForm'
    ),
);

const SocialAccount = loadable(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/socialAccount" */
      '@apps/acquisitionFunnels/createWedding/routes/SocialAccount/SocialAccount'
    ),
);

const WeddingAlreadyExists = loadable(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/weddingAlreadyExists" */
      '@apps/acquisitionFunnels/createWedding/routes/WeddingAlreadyExists/WeddingAlreadyExists'
    ),
);

const ForgotPassword = loadable(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/forgotPassword" */
      '@apps/acquisitionFunnels/createWedding/routes/ForgotPassword/ForgotPassword'
    ),
);

const Survey = loadable(
  () =>
    import(
      /* webpackChunkName: "content/createWedding/survey" */
      '@apps/acquisitionFunnels/createWedding/routes/Survey/Survey'
    ),
);

export const viewMap = {
  createAccount: CreateAccount,
  socialAccount: SocialAccount,
  createWeddingForm: CreateWeddingForm,
  questionnaire: Survey,
  weddingAlreadyExists: WeddingAlreadyExists,
  forgotPassword: ForgotPassword,
  signIn: SignIn,
};

export type SupportedView = keyof typeof viewMap;

const [ViewProvider, useViewContext] = createContext<ViewContext>({ name: 'ViewContext' });

export { ViewProvider, useViewContext };
